import * as React from "react";
import { IOrthodonticReferral } from "../../../models/IOrthodonticReferral";
import { Table } from "soprasteria-ui-library";
import { dateTimeToDateString } from "../../../helpers/DateHelper";
import { Link } from "react-router-dom";
import { PATIENT, ORTHODONTIC_REFERRAL } from "../../../utils/RouteConstants";

interface IOrthodonticReferralProvningskonsultSummaryTable {
    orthodonticReferrals: IOrthodonticReferral[];
}

export const OrthodonticReferralProvningskonsultSummaryTable: React.FunctionComponent<IOrthodonticReferralProvningskonsultSummaryTable> = ({ orthodonticReferrals }) => {
    const renderTableLink = (linkText?: string, patientGuidId?: string, orthodonticReferralId?: number) => {
        return <Link to={`${PATIENT}/${patientGuidId}/${ORTHODONTIC_REFERRAL}/${orthodonticReferralId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <th>Datum skickad</th>
                    <th>Remiss-ID</th>
                    <th>Remitterande vårdgivare</th>
                    <th>Remitterande mottagning</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticReferrals.length > 0 ?
                        orthodonticReferrals.map((orthodonticReferral, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(orthodonticReferral.sentDate), orthodonticReferral.patientGuidId, orthodonticReferral.orthodonticReferralId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral.orthodonticReferralNumber?.toString(), orthodonticReferral.patientGuidId, orthodonticReferral.orthodonticReferralId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral.referrerCareProvider?.displayOrganisationInformation, orthodonticReferral.patientGuidId, orthodonticReferral.orthodonticReferralId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral.referrerCareProvider?.displayCareProviderName, orthodonticReferral.patientGuidId, orthodonticReferral.orthodonticReferralId)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral.orthodonticReferralStatus, orthodonticReferral.patientGuidId, orthodonticReferral.orthodonticReferralId)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={5}>Hittade inga ortodontiremisser</td></tr>
                }
            </tbody>
        </Table>
    )
}